/* eslint-disable no-nested-ternary */
import styled, { css, keyframes } from 'styled-components';

export const Wrapper = styled.section`
  ${({ theme }) => css`
    background: ${theme.palette.white.light};
    min-height: 400px;
    padding: 24px 24px 32px 24px;
    transition: 200ms ease-out;

    @media (max-width: ${theme.breakpoints.md}) {
      padding: 24px 0;
      transition: none;
    }
  `}
`;

export const Question = styled.div``;

export const QuestionTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.palette.grey.dark};
    font-size: ${theme.font.sizes.lg};
    font-weight: ${theme.font.weights.medium};
    margin: 0;
  `}
`;

export const QuestionDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.palette.grey.light};
    font-size: ${theme.font.sizes.md};
    font-weight: ${theme.font.weights.regular};
    margin: 7px 0 0 0;
  `}
`;

export const OptionContent = styled.div`
  align-items: center;
  display: flex;
  padding: 8px;
`;

export const Option = styled.li`
  ${({ theme, selected, visible }) => css`
    background-color: ${selected ? theme.palette.grey.ultralight : theme.palette.white.light};
    border-radius: 5px;
    max-height: ${visible ? '40px' : 0};
    max-width: 600px;
    opacity: ${visible ? 1 : 0};
    overflow: hidden;
    transition: 200ms ease-out;
    will-change: max-height;

    &:not(:first-child) {
      margin-top: ${visible ? (selected ? 0 : '8px') : 0} ;
    }

    &:hover {
      cursor: pointer;
      background-color: ${theme.palette.grey.ultralight};
    }

    @media (max-width: ${theme.breakpoints.md}) {
      transition: none;
      max-height: ${visible ? '88px' : 0};
    }
  `}
`;

export const Options = styled.ul`
  list-style: none;
  margin: 32px 0 0 0;
  padding: 0;
`;

export const OptionButton = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.breakpoints.md}) {
      align-self: start;
    }
  `}
`;

export const OptionText = styled.div`
  ${({ theme }) => css`
    color: ${theme.palette.grey.dark};
    font-size: ${theme.font.sizes.md};
    font-weight: ${theme.font.weights.regular};
    margin-left: 8px;

    @media (max-width: ${theme.breakpoints.md}) {
      flex: 1;
      line-height: 24px;
    }
  `}
`;

export const Reason = styled.div`
  ${({ theme, visible }) => css`
    margin-top: ${visible ? '22px' : 0};
    max-height: ${visible ? '183px' : 0};
    opacity: ${visible ? 1 : 0};
    overflow: hidden;
    transition: 200ms ease-out;
    will-change: max-height;

    @media (max-width: ${theme.breakpoints.md}) {
      transition: none;
    }
  `}
`;

export const ReasonQuestion = styled.h4`
  ${({ theme }) => css`
    color: ${theme.palette.grey.dark};
    font-size: ${theme.font.sizes.md};
    font-weight: ${theme.font.weights.medium};
    margin: 0;
  `}
`;

export const ReasonOption = styled.div`
  margin-top: 16px;
  max-width: 600px;
`;

export const ButtonSupport = styled.div`
  box-sizing: border-box;
  width: 620px;
  height: auto;
  margin-left: 5px;
  margin-top: 30px;
  background: linear-gradient(95.67deg, #ffffff 0%, #e7f3fd 100%);
  border: 1px solid #e7f3fd;
  border-radius: 16px;
  display: flex;
  align-items: center;
  padding: 30px 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
    height: auto;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    margin-left: 0;
    margin-top: 20px;
  }
`;

export const IconContainer = styled.div`
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 120px;
    object-fit: cover;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
    height: auto;
    margin-bottom: 20px;

    img {
      height: 80px;
    }
  }
`;

export const ContentContainer = styled.div`
  width: 75%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  padding-left: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
    align-items: center;
    text-align: center;
    padding-left: 0;
  }
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.palette.primary.darkest};
    font-size: ${theme.font.sizes.lg};
    font-weight: 700;
    margin: 0;

    @media (max-width: ${theme.breakpoints.md}) {
      font-size: ${theme.font.sizes.md};
    }
  `}
`;

export const Subtitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.palette.primary.darkest};
    font-size: ${theme.font.sizes.sm};
    font-weight: 400;
    margin: 0;

    @media (max-width: ${theme.breakpoints.md}) {
      font-size: ${theme.font.sizes.xs};
    }
  `}
`;

const shake = keyframes`
  0%, 40% {
    transform: rotate(0deg) translateY(0);
  }
  60% {
    transform: rotate(-1deg) translateY(2px);
  }
  70% {
    transform: rotate(2deg) translateY(2px);
  }
  85% {
    transform: rotate(-1deg) translateY(2px);
  }
  100% {
    transform: rotate(0deg) translateY(0);
  }
`;

export const SupportButton = styled.button`
  ${({ theme }) => css`
    background: ${theme.palette.blue.vivid};
    color: ${theme.palette.white.light};
    border: none;
    width: 60%;
    border-radius: 30px;
    padding: 10px 15px;
    font-size: ${theme.font.sizes.md};
    font-weight: 300;
    cursor: pointer;
    transition: background 200ms ease-out;

    animation: ${shake} 0.8s ease-in-out infinite;
    animation-delay: 2s;

    &:hover {
      background: ${theme.palette.blue.darkest};
      animation: none;
    }

    @media (max-width: ${theme.breakpoints.md}) {
      width: 90%;
      font-size: ${theme.font.sizes.sm};
    }

    svg{
      width: 15px;
      height: 15px;
    }
  `}
`;
